import React from "react";
import { Button, Form } from "react-bootstrap";
import {getFieldLabel, getOperatorLabel, getValueLabel} from "../../utils/labelUtils";

const ConditionBuilder = ({
                              group,
                              onChange,
                              t,
                          }: {
    group: ConditionGroup;
    onChange: (updatedGroup: ConditionGroup) => void;
    t:any;
}) => {

    const fieldOptions = [
        "type", "total_gross_amount", "tenderType", "item_count", "total_item_return_count",
        "total_void_count", "total_modification_count", "custom_reduction_count",
        "custom_credit_card_usage", "custom_loyalty_card_usage", "is_no_matching_sales",
        "beginDateTime", "duration", "total_return_count", "reduction_percentage",
        "itemType", "employee_reduction_amount", "manager_reduction_amount"
    ].map((field) => ({
        value: field,
        label: getFieldLabel(t, field),
    }));

    const operatorOptions = [
        "eq", "ne", "gt", "gte", "lt", "lte", "contains"
    ].map((op) => ({
        value: op,
        label: getOperatorLabel(t, op),
    }));

    const handleConditionChange = (index: number, updated: Condition) => {
        const newConditions = [...group.conditions];
        newConditions[index] = updated;
        onChange({ ...group, conditions: newConditions });
    };

    const handleGroupChange = (index: number, updated: ConditionGroup) => {
        const newConditions = [...group.conditions];
        newConditions[index] = updated;
        onChange({ ...group, conditions: newConditions });
    };

    const handleJoinChange = (newJoin: "and" | "or") => {
        onChange({ ...group, join: newJoin });
    };

    const addCondition = () => {
        const newConditions = [...group.conditions, { field: "", operator: "eq", value: "" }];
        onChange({ ...group, conditions: newConditions });
    };

    const addGroup = () => {
        const newConditions = [...group.conditions, { join: "and", conditions: [] }];
        onChange({ ...group, conditions: newConditions });
    };

    const removeCondition = (index: number) => {
        const newConditions = group.conditions.filter((_, i) => i !== index);
        onChange({ ...group, conditions: newConditions });
    };


    return (
        <div style={{ paddingLeft: 12, marginBottom: 12 }}>
            {group.conditions.map((cond, idx) => {
                const isLast = idx === group.conditions.length - 1;

                return (
                    <div key={idx}>
                        {"field" in cond ? (
                            <div
                                style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 6 }}
                            >
                                <Form.Select
                                    size="sm"
                                    value={cond.field}
                                    onChange={(e) =>
                                        handleConditionChange(idx, {
                                            ...cond,
                                            field: e.target.value
                                        })
                                    }
                                >
                                    {fieldOptions.map((f) => (
                                        <option key={f.value} value={f.value}>
                                            {f.label}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Form.Select
                                    size="sm"
                                    value={cond.operator}
                                    onChange={(e) =>
                                        handleConditionChange(idx, {
                                            ...cond,
                                            operator: e.target.value,
                                        })
                                    }
                                >
                                    {operatorOptions.map((op) => (
                                        <option key={op.value} value={op.value}>
                                            {op.label}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Form.Control
                                    size="sm"
                                    type="text"
                                    value={getValueLabel(t,cond.value)}
                                    onChange={(e) =>
                                        handleConditionChange(idx, { ...cond, value: e.target.value })
                                    }
                                />

                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => removeCondition(idx)}
                                >
                                    ✕
                                </Button>
                            </div>
                        ) : (
                            <div style={{ borderLeft: "2px dashed #ccc", paddingLeft: 10, position: "relative" }}>
                                <ConditionBuilder
                                    group={cond as ConditionGroup}
                                    onChange={(updated) => handleGroupChange(idx, updated)}
                                    t={t}
                                />
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    style={{ position: "absolute", top: 0, right: 0 }}
                                    onClick={() => removeCondition(idx)}
                                >
                                    ✕
                                </Button>
                            </div>
                        )}

                        {!isLast && (
                            <div
                                style={{
                                    textAlign: "center",
                                    margin: "8px 0",
                                    fontWeight: "bold",
                                    color: "#999",
                                }}
                            >
                                <div style={{ textAlign: "center", margin: "8px 0" }}>
                                    <Form.Select
                                        size="sm"
                                        value={group.join}
                                        style={{ width: 100, margin: "0 auto" }}
                                        onChange={(e) => handleJoinChange(e.target.value as "and" | "or")}
                                    >
                                        <option value="AND">{getOperatorLabel(t, "and")}</option>
                                        <option value="OR">{getOperatorLabel(t, "or")}</option>
                                    </Form.Select>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}

            <div className="d-flex gap-2 mt-2">
                <Button size="sm" variant="outline-success" onClick={addCondition}>
                    + {t("RuleList.add_condition")}
                </Button>
                <Button size="sm" variant="outline-primary" onClick={addGroup}>
                    + {t("RuleList.add_group")}
                </Button>
            </div>
        </div>
    );
};

export default ConditionBuilder;
